import React from 'react'
import { connect } from 'react-redux'

import Button from 'components/Button'
import LazyLoad from 'react-lazyload'
import Placeholder from 'components/Placeholder'

import { SETTINGS_PAGINATION, MODAL_ALERT_TYPES } from 'utils/consts'
import actions from 'store/actions'

import closeBtn from 'assets/images/close.svg'

class ModalAddControllersToGroups extends React.Component {
  state = {
    controllers: [],

    itemsPerPage: SETTINGS_PAGINATION.COUNT_PER_PAGE_MAX,
    pageNumber: SETTINGS_PAGINATION.PAGE_NUMBER,
  }

  async componentDidMount() {
    const { itemsPerPage, pageNumber } = this.state

    try {
      const response = await this.props.fetchControllers(
        itemsPerPage,
        pageNumber
      )
      this.setState({ controllers: response.objects })
    } catch (error) {
      this.props.openModalAlert(MODAL_ALERT_TYPES.TYPE_ERROR, error)
    }
  }

  /**
   * @param {Array<Object>} groups
   * @return {String}
   */
  getNameGroups = groups => {
    return groups.map(group => group.title).join(', ')
  }

  /**
   * @param {Number} controllerID
   */
  toggleController = controllerID => {
    if (this.selectedControllers.has(controllerID)) {
      this.selectedControllers.delete(controllerID)
    } else {
      this.selectedControllers.add(controllerID)
    }
  }

  createGroup = async () => {
    try {
      const { selectedGroups, itemsPerPage, pageNumber } = this.props
      const controllersID = []

      this.selectedControllers.forEach(controller =>
        controllersID.push(controller)
      )

      this.props.closeModal()
      selectedGroups.forEach(async groupID => {
        const data = [
          {
            group_id: groupID,
            employee_id: [],
            access_object_id: controllersID,
          },
        ]
        await this.props.createGroup(data)
        await this.props.fetchGroups({
          count: itemsPerPage,
          page: pageNumber,
        })
      })
      selectedGroups.clear()
    } catch (error) {
      this.props.openModalAlert(MODAL_ALERT_TYPES.TYPE_ERROR, error)
    }
  }

  /**
   * @param {Object} e
   */
  handleScroll = async e => {
    const { itemsPerPage, pageNumber } = this.state
    const element = e.target,
      data = {
        count: itemsPerPage,
        page: pageNumber + 1,
      }

    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      const response = await this.props.fetchControllers(data)
      this.setState(prevState => ({
        controllers: [...prevState.controllers, ...response.objects],
        pageNumber: prevState.pageNumber + 1,
      }))
    }
  }

  render() {
    const { controllers } = this.state
    this.selectedControllers = new Set()

    return (
      <div className='modal-overlay'>
        <div className='modal modal--sm'>
          <div className='modal__header'>
            <p className='modal__title'>Открыть доступ в...</p>
            <Button
              className='button--icon'
              icon={true}
              iconPicture={closeBtn}
              action={this.props.closeModal}
            />
          </div>

          <div className='modal__content'>
            <div
              className='groups-list groups-list--fixed overflow-list'
              onScroll={this.handleScroll}>
              {controllers.map(controller => (
                <LazyLoad
                  key={controller.id}
                  once
                  overflow
                  height={52}
                  offset={[-10, 0]}
                  placeholder={<Placeholder />}
                  debounce={200}>
                  <div className='groups-list__group'>
                    <label>
                      <input
                        type='checkbox'
                        onChange={() => this.toggleController(controller.id)}
                      />
                      <div>
                        <div className='group-name'>{controller.title}</div>
                        <div className='group-controllers'>
                          Группы:{' '}
                          {controller.groups.length
                            ? this.getNameGroups(controller.groups)
                            : 'отсутствуют'}
                        </div>
                      </div>
                    </label>
                  </div>
                </LazyLoad>
              ))}
            </div>
          </div>

          <div className='modal__bottom modal__bottom--right'>
            <Button
              title='Добавить'
              className='btn--lg btn--primary'
              action={this.createGroup}
            />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    controllers: state.controllersInfo,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    createGroup: data => dispatch(actions.groups.createGroup(data)),
    fetchGroups: data => dispatch(actions.groups.fetchGroups(data)),
    fetchControllers: data => dispatch(actions.controllers.fetchControllers(data)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalAddControllersToGroups)
